<template>
  <Breadcrumbs main="Ecommerce" title="" />
  <div class="container-fluid text-start">
    <div class="row">
      <div class="col-sm-12">
        <div class="card" v-if="Object.keys(cart_store.cart).length <= 0 && Object.keys(cart_store.cart_vdo).length <= 0">
          <div class="card-body">
            <div class="card-header">
              <h4>{{this.currentLanguage ==='en'?"Order information":"รายการสั่งซื้อ และชำระเงิน"}}</h4>
            </div>
            <div class="row">
              <div class="d-flex justify-content-center">
                <div class="card-header">
                  <vue-feather
                    type="shopping-cart"
                    style="width: 100px; text-align: center"
                  ></vue-feather>
                  <h5>{{this.currentLanguage ==='en'?"Not found":"ไม่พบรูปในตะกร้า"}}</h5>
                </div>
              </div>
            </div>
            <div class="row">
              <button class="btn btn-primary" @click="prvback()">
                {{this.currentLanguage ==='en'?"search again":"เริ่มค้นหารูปใหม่"}}
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card">
            <div class="card-body">
              <div style="padding-top: 20px;">
                <h4>{{this.currentLanguage ==='en'?"Order information":"รายการสั่งซื้อ และชำระเงิน"}}</h4>
                <p>
                  <b>{{this.currentLanguage ==='en'?"Event":"กิจกรรม"}} {{ this.eventDetails.title }} </b>
                </p>
                <p>
                  <span style="padding: 5px;margin: 3px;"
                    v-for="(_package, index) in this.eventPackage"
                    :key="index"
                    class="package-tag">
                    <b>{{this.currentLanguage ==='en'?_package.name_en:_package.name}}</b>
                  </span>
                  
                </p>
                <!-- {{ this.cart_store.total }}  -->
                  
              </div>

              <!-- start Implement videoeventDetails: {{ this.eventDetails }}<br><br>
               cart_store:===> {{ cart_store }}<br><br>
                cart_store VDO:===> {{ cart_store.cart_vdo }}<br><br> -->
              <span v-if="this.eventDetails.is_enable_vdo ==='Y' && cart_store.cart_vdo.length > 0">
              <hr>
              <p v-if="this.currentLanguage ==='th'"><b>วิดีโอทั้งหมดในตะกร้า {{ cart_store.cart_vdo.length }} ใบ</b> (เลื่อนเพื่อดูวิดีโอทั้งหมด)</p>
              <p v-if="this.currentLanguage ==='en'"><b>There are {{ cart_store.cart_vdo.length }} videos in the cart </b> (scroll to view all).</p>
              <div class="custom-border " style="overflow:auto;height: 300px;background-color: #dbdbdb;border-radius: 0.4em">
                <div
                  v-for="(src, index) in cart_store.cart_vdo"
                  :key="index"
                  class="gallery gellerycont"
                >
                  <img
                    :src="src.thumbnail_file_name"
                    :alt="src.original_file_name"
                    loading="lazy"
                  />
                  <span class="video-indicator" aria-label="Video">
                    <vue-feather type="video" size="14"></vue-feather>
                  </span>
                  <input type="checkbox" :id="src.id" />
                  <label style="font-size: small;"
                    class="btn"
                    @click="
                      cart_store.removeImageInCart_video(src.id),
                        this.checkOnceEventId()
                    "
                    :for="src.id"
                    >{{this.currentLanguage ==='en'?"Remove":"-ลบ"}}</label
                  >
                </div>
              </div>
             
              </span>
              <!-- end implement video -->

              <span v-if="cart_store.cart.length > 0">
              <hr>
              <p v-if="this.currentLanguage ==='th'"><b>รูปทั้งหมดในตะกร้า {{ cart_store.cart.length }} ใบ</b> (เลื่อนเพื่อดูรูปทั้งหมด)</p>
              <p v-if="this.currentLanguage ==='en'"><b>There are {{ cart_store.cart.length }} images in the cart </b> (scroll to view all).</p>
              <div class="container-fluid custom-border " style="overflow:auto;height: 500px;background-color: #dbdbdb;border-radius: 0.4em">
                <div
                  v-for="(src, index) in cart_store.cart"
                  :key="index"
                  class="gallery gellerycont"
                >
                  <img
                    :src="src.thumbnail_file_name"
                    :alt="src.original_file_name"
                    loading="lazy"
                  />

                  <input type="checkbox" :id="src.id" />
                  <label style="font-size: small;"
                    class="btn"
                    @click="
                      cart_store.removeImageInCart(src.id),
                        this.checkOnceEventId()
                    "
                    :for="src.id"
                    >{{this.currentLanguage ==='en'?"Remove":"-ลบ"}}</label
                  >
                </div>
              </div>
              </span>
            </div>

            <div class="card-body">
              <div class="card-header">
                <div class="row">
                  <div class="row">
                    <button class="btn btn-primary" @click="prvback()">
                      {{this.currentLanguage ==='en'?"Add more items":"กลับไปค้นหาอีกครั้ง"}}
                    </button>
                    <h3></h3>

                    
                    <button v-if="this.eventDetails.is_enable_vdo ==='Y'"
                      class="btn btn-danger"
                      @click="cart_store.clear_all_cart_in_cart_page_vdo()"
                    >
                      {{this.currentLanguage ==='en'?"Remove all":"ลบรูปและวิดีโอทั้งหมดในตะกร้า"}}
                    </button>
                  </div>
                  <div class="row" v-if="this.eventDetails.is_enable_vdo ==='N'">
                    <button 
                    class="btn btn-danger"
                    @click="cart_store.clear_all_cart_in_cart_page()"
                  >
                    {{this.currentLanguage ==='en'?"Remove all":"ลบรูปทั้งหมดในตะกร้า"}}
                  </button>
                    <h3></h3>
                    <button v-if="this.is_mhao_flag_init === 'Y' && this.cart_store.is_mhao_flag === 'YES' "
                      class="btn btn-primary"
                      @click.prevent="
                        this.cart_store.clear_mhao(
                          'N',
                          this.eventDetails.is_mhao,
                          this.eventDetails.mhao_price,
                          'Y'
                        )
                      "
                    >
                      -<vue-feather
                        type="shopping-cart"
                        stroke-width="2"
                      ></vue-feather>
                      {{this.currentLanguage ==='en'?"Cancel":"ยกเลิกการเลือกโปรเหมาๆ"}}
                    </button>

                    <button
                      v-if="
                        this.is_mhao_flag_init === 'Y' &&
                        this.cart_store.is_mhao_flag !== 'YES'
                      "
                      class="btn btn-primary"
                      @click.prevent="
                        this.cart_store.select_pro_mhao(
                          'Y',
                          this.eventDetails.is_mhao,
                          this.eventDetails.mhao_price
                        )
                      "
                    >
                      +<vue-feather
                        type="shopping-cart"
                        stroke-width="2"
                      ></vue-feather>
                      {{ this.eventDetails.caption_button_buy_all }} ( {{this.currentLanguage ==='en'?"Avg":"เฉลี่ย"}}
                      {{
                        (
                          this.eventDetails.mhao_price /
                          this.cart_store.cart_latest.length
                        ).toFixed(2)
                      }}
                      ) {{this.currentLanguage ==='en'?"per item":"ต่อใบ"}}
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="table-responsive"
                style="margin-left: auto; margin-right: 0"
              >
                <table
                  class="table align-to-right"
                  style="width: 80%; text-align: center"
                >
                  <thead>
                    <tr class="border-bottom-light">
                      <th scope="col" style="text-align: right; width: 50%">
                        
                        <p v-if="this.currentLanguage ==='th'" >จำนวนรูป ({{ cart_store.cart.length }} ใบ) <span v-if="this.eventDetails.is_enable_vdo === 'Y'" >, วีดีโอ ({{ cart_store.cart_vdo.length }} ใบ)</span></p>
                        <p v-if="this.currentLanguage ==='en'">Number of photos ({{ cart_store.cart.length }} ) <span v-if="this.eventDetails.is_enable_vdo === 'Y'" >, Videos ({{ cart_store.cart_vdo.length }} )</span></p>
                      </th>
                      <th scope="col" style="text-align: right">
                        {{ this.cart_store.cal_cart.cart_full_amt_no_pomo }} {{ this.eventDetails.payment_currency || 'THB' }}
                      </th>
                    </tr>
                  </thead>
                  <!-- <tbody>
                    <tr class="border-bottom-light">
                      <th scope="col" style="text-align: right">ยอดรวม</th>
                      <th scope="col" style="text-align: right">
                       <b><span
                            v-if="this.cart_store.is_mhao_flag === 'YES'"
                            class="badge badge-pill badge-info"
                            ><vue-feather
                              type="paperclip"
                              size="20"
                            ></vue-feather
                            ><b>เลือกโปรเหมาๆ</b>
                          </span> {{ this.cart_store.cal_cart.cart_full_amt }}
                        {{ this.eventDetails.payment_currency || 'THB' }}</b>
                      </th>
                    </tr>
                  </tbody> -->

                  <tbody>
                    <tr class="border-bottom-light">
                      <th scope="col" style="text-align: right">
                        <p>
                          <!-- <span style="padding: 5px;margin: 3px;"
                            v-for="(_package, index) in this.eventPackage"
                            :key="index"
                            class="badge badge-pill badge-info"
                            ><vue-feather
                              type="paperclip"
                              size="20"
                            ></vue-feather
                            ><b>{{this.currentLanguage ==='en'?_package.name_en:_package.name}}</b>
                          </span> -->
                          {{this.currentLanguage ==='en'?"Discount":"ส่วนลด"}}
                        </p>
                      </th>
                      <th
                        scope="col"
                        style="text-align: right; vertical-align: bottom"
                      >
                        <p style="color: red; text-decoration: line-through;">
                          <span v-if="this.cart_store.cal_cart.cart_discount >0">-</span> {{ this.cart_store.cal_cart.cart_discount }} {{ this.eventDetails.payment_currency || 'THB' }}
                        </p>
                      </th>
                    </tr>
                  </tbody>

                  <tbody>
                    <tr class="border-bottom-dark">
                      <th scope="col" style="text-align: right">
                        {{this.currentLanguage ==='en'?"Total":"ยอดรวมหลังหักส่วนลด"}}
                      </th>
                      <th scope="col" style="text-align: right">
                        {{ this.cart_store.total }}
                        {{ this.eventDetails.payment_currency || 'THB' }}
                      </th>
                    </tr>
                  </tbody>

                  <tbody>
                    <tr class="border-bottom-white">
                      <th scope="col" style="text-align: right">
                        {{ this.currentLanguage === 'en' ? 'Fees' : vatOrFeeDesc }} ({{ vatOrFeeText }})
                      </th>
                      <th scope="col" style="text-align: right">
                        {{ this.cart_store.cal_cart.cart_payment_fee }}
                        {{ this.eventDetails.payment_currency || 'THB' }}
                      </th>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr class="border-bottom-primary">
                      <th scope="col" style="text-align: right">
                        {{this.currentLanguage ==='en'?"Total payment":"ยอดชำระสุทธิ"}}
                      </th>
                      <th scope="col" style="text-align: right">
                        <b>
                          {{ this.cart_store.cal_cart.cart_final_payment }}
                          {{ this.eventDetails.payment_currency || 'THB' }}</b
                        >
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row" v-if="this.is_once_event_id === 'N'">
            <div class="d-flex justify-content-center">
              <h2 style="color: red">
                <u>{{this.currentLanguage ==='en'?"Pls choose image from only once event":"กรุณาเลือกรูปในตะกร้าที่มาจากกิจกรรมเดียวกัน เท่านั้น"}}</u>
              </h2>
            </div>
            <div>&nbsp;</div>
          </div>

          
          
          
          <form @submit.prevent="submitCart" class="needs-validation"
            v-if="this.is_once_event_id !== 'N' && this.eventDetails.is_free_download_keep_contract !== 'Y' "
          >
            <div class="col-lg-12">
              <div class="row">
                <div style="padding: 5px;" class="col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <h6 class="f-w-500"></h6>
                          <div class="row">
                            <div class="mb-3 col-sm-6">
                              <label for="moblieNo" class="form-label"
                                ><h3>
                                  {{this.currentLanguage ==='en'?"Mobile number":"หมายเลขโทรศัพท์"}}
                                  <span style="color: red">*</span>
                                </h3>
                                
                                <small class="form-text text-muted"
                                  >{{this.currentLanguage ==='en'?"Input only number":"ป้อนแค่ตัวเลขไม่ต้องมีขีด,ระบบจะแสดงลิงค์ดาวน์โหลดภาพทันที เมื่อชำระเงินสำเร็จ"}}
                                </small>
                              </label>
                              <input
                                required
                                maxlength="15"
                                minlength="5"
                                inputmode="numeric"
                                autocomplete="off"
                                type="text"
                                class="form-control"
                                id="moblieNo"
                                placeholder="ex.0901234567"
                                v-model="this.cart_store.mobileNo"
                              />
                            </div>
                            <div class="mb-3 col-sm-6">
                              <label for="email"
                                ><h3>Email <span
                                    style="
                                      font-size: small;
                                      background: inherit;
                                      color: red;
                                    "
                                    >{{this.currentLanguage ==='en'?"":"(ถ้ามี)"}}</span
                                  >
                                </h3>
                                <small class="form-text text-muted"
                                  >{{this.currentLanguage ==='en'?"Optional":"หากไม่มีให้เว้นว่าง"}}
                                </small>
                              </label>
                              <input
                                type="email"
                                class="form-control"
                                id="email"
                                inputmode="email"
                                placeholder="ex.info@gmail.com"
                                v-model="this.cart_store.email"
                              />
                            </div>
                            <b style="color: red;"
                              >** <vue-feather type="mail" size="15"></vue-feather>
                              {{this.currentLanguage ==='en'?"If you don't receive an SMS, Email or forget your order You can find it in the menu ":"หากไม่ได้รับ SMS Email หรือลืมคำสั่งซื้อ สามารถค้นหาได้ที่เมนู"}}
                              
                              <a href="/find-order" target="_blank"
                                ><u>{{this.currentLanguage ==='en'?"Find orders":"ค้นหาคำสั่งซื้อ"}}</u></a
                              >
                              {{this.currentLanguage ==='en'?"above":"ด้านบน"}}</b
                            >
                          </div>
                          <hr>
                          <div class="row">
                          <div class="col-sm-12 col-lg-12 col-xl-6" v-if="this.eventDetails.is_order_team ==='Y'">
                          <div class="form-floating mb-3">
                            <select class="form-select" required id="floatingSelect" v-model="order_team"
                              aria-label="Floating label select example">
                              <option v-for="(order_team_type, index) in this.eventDetails.order_team" :key="index"
                                :value="order_team_type.name">{{ order_team_type.name }}</option>
                            </select>
                            <label for="floatingSelect">{{this.currentLanguage ==='en'?"Team,Gim,Coach Name,":"ทีม,ยิม,โค้ช"}}</label>
                          </div>
                        </div>

                          <div class="col-sm-8 col-lg-8 col-xl-3" v-if="this.eventDetails.is_coupon ==='Y'" style="padding-bottom: 5px;" >
                              <input type="text" :disabled="this.is_apply_coupon==='Y'" v-model="coupon_code" autocomplete="off" inputmode="txt"
                                class="form-control" minlength="10" maxlength="10" id="floatingInput" placeholder="กรอกคูปอง/ Coupon code">                            
                        </div> 
                        <div class="col-sm-4 col-lg-4 col-xl-3"  v-if="this.eventDetails.is_coupon ==='Y'" >
                            <div class="form-floating mb-0">
                              <button v-if="this.is_apply_coupon==='N'" type="button" @click.prevent="get_coupon" style="cursor: pointer;" class="btn btn-primary" > ใช้คูปอง/Apply Coupon</button>
                            
                              <span v-if="this.is_apply_coupon==='Y'" style="color: green;padding-left: 10px;"><br><vue-feather stroke="green" type="check-circle" size="20"> </vue-feather>  {{this.currentLanguage ==='th'? this.coupon_obj.description:this.coupon_obj.description_en}} (กรุณาตรวจสอบยอดชำระสุทธิ อีกครั้งก่อนสร้างคำสั่งซื้อ)</span>
                              <span v-if="this.is_found_coupon==='N'" style="color: red;padding-left: 10px;"><vue-feather stroke="red" type="x-circle" size="20"> </vue-feather>  {{this.currentLanguage ==='th'? this.coupon_obj.description:this.coupon_obj.description_en}}</span>

                            </div>
                        </div>
                      </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style="padding: 5px;" class="col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="media">
                        <vue-feather
                          class="m-r-30"
                          type="credit-card"
                        ></vue-feather>
                        <div class="media-body">
                          <h6 class="f-w-500">
                            <h3>
                              {{this.currentLanguage ==='en'?"Payment method":"ช่องทางการชำระเงิน"}}
                              <span style="color: red">*</span>
                            </h3>
                          </h6>
                          <small class="form-text text-muted"
                            >{{this.currentLanguage ==='en'?"The system will immediately display a link to download the image. Upon successful payment, a link to download the images will be sent via SMS or email.":"ระบบจะแสดงลิงค์ดาวน์โหลดภาพทันที เมื่อชำระเงินสำเร็จ, ลิงค์สำหรับดาวน์โหลดภาพจะถูกส่งให้ทาง SMS หรืออีเมลล์ด้วย"}}</small
                          >
                          <p>&nbsp;</p>
                          <div class="form-check" v-if="this.eventDetails.payment_currency === 'THB'">
                            <h6>
                              <input
                                required
                                class="form-check-input"
                                type="radio"
                                v-model="this.cart_store.paymentMethod"
                                value="PP"
                                name="paymentMethod"
                                id="QR"
                              />
                              <label class="form-check-label" for="QR">
                                &NonBreakingSpace; <b>{{this.currentLanguage ==='en'?"PromptPay":"พร้อมเพย์ (PromptPay)"}}</b>
                                <img
                                  style="width: 100px"
                                  src="../../assets/images/running/promptpay-icon.jpg"
                                />
                              </label>
                            </h6>
                          </div>
                          
                          <div class="form-check">
                            <input
                              required
                              class="form-check-input"
                              value="CC"
                              type="radio"
                              v-model="this.cart_store.paymentMethod"
                              name="paymentMethod"
                              id="CREDIT"
                            />
                            <label class="form-check-label" for="CREDIT">
                              &NonBreakingSpace;
                              <b>{{this.currentLanguage ==='en'?"Credit Card/debit (VISA, Mastercard, American Express)":"บัตรเครดิต/เดบิต(Credit Card/debit)"}}</b>
                              <img
                                style="width: 100px"
                                src="../../assets/images/running/credit-card-icon.png"
                              />
                              <p>
                                &nbsp;&nbsp;<small
                                  style="font-size: xx-small"
                                  class="form-text text-muted"
                                  >{{this.currentLanguage ==='en'?"3D secure credit card payments":"การชำระเงินผ่านบัตรเครดิตแบบ 3D secure"}}</small
                                >
                              </p>
                            </label>
                          </div>
                          
                          <div class="form-check" v-if="this.systemprefix==='SA'">
                            <input
                              required
                              class="form-check-input"
                              value="AM"
                              type="radio"
                              v-model="this.cart_store.paymentMethod"
                              name="paymentMethod"
                              id="ADDMORE"
                            />
                            <label class="form-check-label" for="ADDMORE">
                              &NonBreakingSpace;
                              <b>{{this.currentLanguage ==='en'?"Get more images after your get Unlimited Package":"ขอรูปเพิ่มเติมหลังจากเหมาไปแล้ว"}}</b>
                              <p>
                                &nbsp;&nbsp;<small
                                  style="font-size: xx-small"
                                  class="form-text text-muted"
                                  >{{this.currentLanguage ==='en'?"After placing your order, please message the admin on the "+ systemName +" page so they can verify and approve it (no additional payment required)":"หลังจากสร้างออร์เดอร์ กรุณาทักหาแอดมินที่เพจ "+ systemName +" เพื่อให้แอดมินตรวจสอบ และอนุมัติ(ไม่ต้องจ่ายเงินเพิ่ม)"}}</small
                                >
                                <input v-if="this.cart_store.paymentMethod==='AM'"
                                required
                                maxlength="20"
                                minlength="5"
                                type="text"
                                class="form-control"
                                id="am_order_ref"
                                :placeholder="this.currentLanguage==='en'?'The order no or mobile from your previous unlimited package for reference':'รหัสคำสั่งซื้อหรือเบอร์โทรศัพท์จากที่เหมาแล้วก่อนหน้านี้ เพื่ออ้างอิงการขอรูปเพิ่มเติม'"
                                v-model="this.cart_store.amOrderRef"
                              />
                              </p>
                              
                            </label>
                          </div>

                          <div class="row">&nbsp;</div>

                          <div class="row">
                            <div class="d-flex justify-content-center">
                              <button
                                type="submit"
                                style="cursor: pointer"
                                class="btn btn-primary col-12"
                                :disabled="this.is_submit_cart === 'Y'?'':disabled"
                              >
                              <span v-if="this.is_submit_cart === 'Y'" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {{this.currentLanguage ==='en'?"Create Order":"สร้างคำสั่งซื้อ"}}
                              </button>
                              <!-- &nbsp;
                              <button
                                style="cursor: pointer"
                                type="reset"
                                class="btn btn-secondary btn-lg"
                              >
                                {{this.currentLanguage ==='en'?"Cancel":"ยกเลิก"}}
                              </button> -->
                            </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </form>
     <br>
          <form  @submit.prevent="submitCart" class="needs-validation"
            v-if="this.is_once_event_id !== 'N' && this.eventDetails.is_free_download_keep_contract === 'Y' && this.cart_store.cal_cart.cart_final_payment === '0.00'"
          >
            <div class="col-lg-12">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <br>
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <div class="row">
                            <div class="mb-3 col-sm-6">
                              <label for="moblieNo" class="form-label"
                                ><h3>
                                  {{this.currentLanguage ==='en'?"Mobile number":"หมายเลขโทรศัพท์"}}
                                  <span style="color: red">*</span>
                                </h3>
                                
                                <small class="form-text text-muted"
                                  >{{this.currentLanguage ==='en'?"Input only number":"ระบบจะแสดงลิงค์ดาวน์โหลดภาพทันที เมื่อกดปุ่มสร้างออร์เดอร์"}}
                                </small>
                              </label>
                              <input
                                required
                                maxlength="10"
                                minlength="10"
                                inputmode="numeric"
                                autocomplete="off"
                                type="text"
                                class="form-control"
                                id="moblieNo"
                                placeholder="ex.0901234567"
                                @input="validateMobileNoInput"
                                v-model="this.cart_store.mobileNo"
                              />
                            </div>
                            <div class="mb-3 col-sm-6">
                              <label for="email"
                                ><h3>Email <span
                                    style="
                                      font-size: small;
                                      background: inherit;
                                    "
                                    >{{this.currentLanguage ==='en'?"":"(ถ้ามี)"}}</span
                                  >
                                </h3>
                                <small class="form-text text-muted"
                                  >{{this.currentLanguage ==='en'?"Optional":"หากไม่มีให้เว้นว่าง"}}
                                </small>
                              </label>
                              <input
                                type="email"
                                class="form-control"
                                id="email"
                                inputmode="email"
                                placeholder="ex.abc@gmail.com"
                                v-model="this.cart_store.email"
                              />
                            </div>
                            <b
                              ><vue-feather type="search" size="15"></vue-feather>
                              {{this.currentLanguage ==='en'?" If you forget your order You can find it in the menu ":" หากลืมคำสั่งซื้อ สามารถค้นหาได้ที่เมนู"}}
                              
                              <a href="/find-order" target="_blank"
                                ><u>{{this.currentLanguage ==='en'?"Find orders":"ค้นหาคำสั่งซื้อ"}}</u></a
                              >
                              {{this.currentLanguage ==='en'?"above":"ด้านบน"}}</b
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p>&nbsp;</p>
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <br>
                      <div class="media">
                        <vue-feather
                          class="m-r-30"
                          type="image"
                        ></vue-feather>
                        <div class="media-body">
                          <h6 class="f-w-500">
                            <h3>
                              {{this.currentLanguage ==='en'?"Event free download":"กิจกรรมรับภาพฟรี"}}
                            </h3>
                          </h6>
                          <small class="form-text text-muted"
                            >{{this.currentLanguage ==='en'?"The system will immediately display a link to download the image. A link to download the image will be sent via email. (If entered email)":"ระบบจะแสดงลิงค์ดาวน์โหลดภาพทันที, ลิงค์สำหรับดาวน์โหลดภาพจะถูกส่งให้ทางอีเมลล์ (ถ้าป้อนข้อมูล)"}}</small
                          >
                          <p>&nbsp;</p>
                          
                          <div class="row">&nbsp;</div>

                          <div class="row">
                            <div class="d-flex justify-content-center">
                              <button
                                type="submit"
                                style="cursor: pointer"
                                class="btn btn-primary btn-lg"
                                :disabled="this.is_submit_cart === 'Y'?'':disabled"
                              >
                                <vue-feather
                                  type="loader"
                                  size="20"
                                  animation="spin"
                                  v-if="this.is_submit_cart === 'Y'"
                                ></vue-feather>
                                {{this.currentLanguage ==='en'?"Create order":"สร้างออร์เดอร์"}}
                              </button>
                              &nbsp;
                              <button
                                style="cursor: pointer"
                                type="reset"
                                class="btn btn-secondary btn-lg"
                              >
                                {{this.currentLanguage ==='en'?"Cancel":"ยกเลิก"}}
                              </button>
                            </div>
                          </div>

                          

                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div style="color: rgba(153, 71, 71, 0)">
            {{ this.cart_store.total }}
          </div>
          <!-- this.cart_store._package : {{ this.cart_store._package }} <br /><br />
          this.cart_store: {{ this.cart_store.cart }} <br />
          this.cart_store VDO: {{ this.cart_store.cart_vdo }} <br /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useCartStore } from "../../store/modules/cart";
import router from "../../router/index";
import axios from "axios";
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
export default {
  setup() {
    const siteData = reactive({
      title: process.env.VUE_APP_SYSTEM_NAME,
      description: process.env.VUE_APP_SYSTEM_NAME,
      keywords: process.env.VUE_APP_SYSTEM_NAME,
      image:  process.env.VUE_APP_WEBSITE_IMAGE,
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    })

    const cart_store = useCartStore();
    cart_store.loadFromLocalStorage();

    return { cart_store };
  },
  data() {
    return {
      systemName: process.env.VUE_APP_SYSTEM_NAME,
      vatOrFeeDesc: process.env.VUE_APP_VAT_OR_FEE_DESC,
      vatOrFeeText: process.env.VUE_APP_VAT_OR_FEE_TEXT,
      eventDetails: {},
      eventPackage: [{}],
      cart_amount: 0,
      is_pic_me: false,
      is_mhao_flag_init: null,
      is_submit_cart: "",
      is_once_event_id: "Y",
      currentLanguage: 'th',
      coupon_code: "",
      is_apply_coupon: "N",
      is_found_coupon: "",
      coupon_obj: {},
      systemprefix: process.env.VUE_APP_SYSTEM_PREFIX
      //is_mhao_flag: this.cart_store.is_mhao_flag.value
    };
  },
  async created() {
      //console.log("cart_store.cart_vdo.length: ", this.cart_store.cart.length);
      if(this.cart_store.cart.length > 0){
        let isOnceEvent = this.checkOnceEventId();
        if (isOnceEvent === "Y") {
          this.prepareCart();
        }
      }

      //console.log("cart_store.cart_vdo.length: ", this.cart_store.cart_vdo.length);
      if(this.cart_store.cart_vdo.length > 0){
       // console.log("checkOnceEventIdVideo called");
        let isOnceEventVideo = await this.checkOnceEventIdVideo();
        //console.log("isOnceEventVideo: ", isOnceEventVideo);
        if (isOnceEventVideo === "Y") {
         // console.log("prepareCartVideo called");
          this.prepareCartVideo();
        }
      }

      
      
    

    this.currentLanguage = localStorage.getItem('currentLanguage');
  },
  async mounted() {
    //console.log("this.cart_store.total mounted: " + this.cart_store.total);
  },
  computed() {
    // console.log("computed");
    //this.cart_amount = this.cart_store.cart.value.reduce((sum, prd) => sum + 60 * 1, 0)
    //console.log("computed1");
  },
  async beforeMount() {
    //console.log("beforeMount counter: ");
  },
  methods: {
    async get_coupon(){
      
    if(this.coupon_code === null || this.coupon_code === ""){
        alert(this.currentLanguage === 'en' ? "Please enter a coupon code." : "กรุณากรอกคูปอง");
        return;
      }
      let data = {
        event_key : this.eventDetails.event_key,
        coupon_code: this.coupon_code
      }
      this.coupon_obj = (await axios.post("v3/order/coupon", data)).data;

      if(this.coupon_obj.is_found_coupon === 'Y'){
        const couponType = String(this.coupon_obj.type || '').toUpperCase();
        const hasIncompatibleItems =
          (couponType === 'IMAGE' && this.cart_store.cart_vdo.length > 0) ||
          (couponType === 'VIDEO' && this.cart_store.cart.length > 0);

        if (hasIncompatibleItems) {
          this.is_apply_coupon = "N";
          this.is_found_coupon = "";
          this.cart_store.coupon_discount = 0;
          alert(this.currentLanguage === 'en'
            ? couponType === 'IMAGE'
              ? "This coupon can only be used for images. Please remove videos and apply the coupon again."
              : "This coupon can only be used for videos. Please remove images and apply the coupon again."
            : couponType === 'IMAGE'
              ? "คูปองของคุณสามารถใช้ได้กับรูปภาพเท่านั้น กรุณาลบวิดีโอออก แล้วกดใช้คูปองอีกครั้ง"
              : "คูปองของคุณสามารถใช้ได้กับวิดีโอเท่านั้น กรุณาลบภาพออก แล้วกดใช้คูปองอีกครั้ง");
          return;
        }

        this.is_apply_coupon = "Y"
        this.is_found_coupon = "Y"
      }else{
        this.is_apply_coupon = "N"
        this.is_found_coupon = "N"
      }
      this.cart_store.coupon_discount_type = this.coupon_obj.discount_type
      this.cart_store.coupon_discount = this.coupon_obj.discount


    },
    async validateMobileNoInput(event){
      const value = event.target.value
      const filtered = value.replace(/[^0-9]/g, '')
      this.cart_store.mobileNo = filtered
    },
    async insertLogs(image_id, event_key) {
      let data = {
        service: "cart",
        cart_count: this.cart_store.cart.length,
        image_id: image_id,
        list: this.cart_store.cart.map(item => item.id).join(','),
        event_key: event_key,
      };
      const res = await axios.post("/v1/logs/", data);
    },
    async insertLogsVideo(image_id, event_key) {
      let data = {
        service: "cart-video",
        cart_count: this.cart_store.cart_vdo.length,
        image_id: image_id,
        list: this.cart_store.cart_vdo.map(item => item.id).join(','),
        event_key: event_key,
      };
      const res = await axios.post("/v1/logs/", data);
    },
    async getEventkeyById(image_id) {
      const res = await axios.get("/v1/events/event-key/" + image_id);
      return res.data.event_key;
    },
    async getEventkeyByIdVideo(video_id) {
      const res = await axios.get("/v1/events/event-key-video/" + video_id);
      return res.data.event_key;
    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data) {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;
        this.is_mhao_flag_init = this.eventDetails.is_mhao;
        localStorage.setItem("_event_can_mhao",this.is_mhao_flag_init === "Y" ? "YES" : "NO");
        //localStorage.setItem("_is_enable_vdo",this.eventDetails.is_enable_vdo);
        this.cart_store._is_enable_vdo = this.eventDetails.is_enable_vdo;
        //console.log("eventDetailsxxxxxxxxxxxxxxxxxxx:", this.eventDetails);
        if(this.eventDetails.is_enable_vdo === 'Y'){
          localStorage.setItem("_mhao_price", this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price : 0 )
          localStorage.setItem("_mhao_price_vdo", this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price_vdo : 0 )
          localStorage.setItem("_mhao_price_both", this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price_both : 0 )

          // if(this.cart_store.currentFilter === 'video'){
          //   localStorage.setItem("_mhao_price", this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price_vdo : 0 )
          // }else if (this.cart_store.currentFilter === 'both'){
          //   localStorage.setItem("_mhao_price",this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price_both : 0 )
          // }else{
          //   localStorage.setItem("_mhao_price",this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price : 0 );
          // }
        
          }else{
            localStorage.setItem("_mhao_price",this.is_mhao_flag_init === "Y" ? this.eventDetails.mhao_price : 0
          );
        }
        
        return res.data;
      }
    },
    prvback() {
      router.push("/");
    },
    async submitCart() {
      if (this.coupon_code !== null && this.coupon_code !== "" && this.is_apply_coupon !== "Y") {
        alert(this.currentLanguage === 'en'
          ? "You have entered a coupon code. Please click 'Apply Coupon' before creating an order."
          : "ในกรณีที่ท่านป้อนข้อมูลคูปอง กรุณากดใช้คูปองก่อน");
        return;
      }


      this.is_submit_cart = "Y";

      //load config payment gateway
      const data = {
        tk: process.env.VUE_APP_FN_TO_BK_SECRET_KEY,
        conf_name: "PAYMENT_GATEWAY",
      };
      const res_conf = await axios.post("v1/utils/conf", data);

      let payment_gateway = res_conf.data.body.value;
      if (payment_gateway === null || payment_gateway === "") {
        alert("พบข้อผิดพลาดกรุณาแจ้งผู้ดูแลระบบ");
      } else {


        if(this.eventDetails.is_coupon ==='Y'  && this.coupon_code !== "" && this.cart_store.cal_cart.cart_final_payment === '0.00'){
          console.log("free download with coupon code");
          payment_gateway = "OPN"
          this.cart_store.paymentMethod = "CC"
        }
        
        const req = {
          mobile: this.cart_store.mobileNo,
          email: this.cart_store.email,
          event_key: this.eventDetails.event_key,
          event_id: this.eventDetails.event_id,
          amount: this.cart_store.cal_cart.cart_amt,
          paid_amount: this.cart_store.cal_cart.cart_final_payment,
          imageList: this.cart_store.cart,
          image_length: this.cart_store.cart.length,
          is_mhao: this.cart_store.is_mhao_flag === "YES" ? "Y" : "N",
          payment_gateway: payment_gateway,
          payment_channel: this.cart_store.paymentMethod,
          order_team: '',
          coupon_code: this.coupon_code,
          am_order_ref: this.cart_store.amOrderRef,
          is_enable_vdo: this.eventDetails.is_enable_vdo,
          videoList: this.cart_store.cart_vdo,
          video_length: this.cart_store.cart_vdo.length,
          payment_currency: this.eventDetails.payment_currency,
        };

        let order_res = await this.cart_store.order_creation(req);
        //console.log("order_createion_r:", order_res);

        if (order_res.status === "success") {
          this.is_submit_cart = "N";
          this.cart_store.clear_all_cart_in_cart_page();
          this.cart_store.clear_all_cart_in_cart_page_vdo();
          if(this.currentLanguage === 'en'){
            await this.cart_store.alert_create_order_en(order_res.uuid);
            this.$router.push("/download/" + order_res.uuid);
          }else{
            await this.cart_store.alert_create_order(order_res.uuid);
            this.$router.push("/download/" + order_res.uuid);
          }

        } else {
          //console.log("order creation errorx: ", order_res);
          await this.cart_store.alert_create_order_failed();
          this.is_submit_cart = "N";
        }
      }
    },
    async checkOnceEventId() {
      let event_id_tmp = "";
      this.is_once_event_id = "Y";

      this.cart_store.cart.forEach((img) => {
        if (event_id_tmp === "") {
          event_id_tmp = img.event_id;
        } else {
          if (event_id_tmp !== img.event_id) {
            this.is_once_event_id = "N";
          }
        }
      });
      //console.log("checkOnceEventId:"+ this.is_once_event_id)
      this.prepareCart();
      return this.is_once_event_id;
    },async checkOnceEventIdVideo() {
      let event_id_tmp = "";
      this.is_once_event_id = "Y";

      this.cart_store.cart_vdo.forEach((img) => {
        if (event_id_tmp === "") {
          event_id_tmp = img.event_id;
        } else {
          if (event_id_tmp !== img.event_id) {
            this.is_once_event_id = "N";
          }
        }
      });
      //console.log("checkOnceEventIdVideo:"+ this.is_once_event_id)
      //this.prepareCartVideo();
      return this.is_once_event_id;
    },
    async checkOnceEventIdVideo() {
      let event_id_tmp = "";
      this.is_once_event_id = "Y";

      this.cart_store.cart_vdo.forEach((img) => {
        if (event_id_tmp === "") {
          event_id_tmp = img.event_id;
        } else {
          if (event_id_tmp !== img.event_id) {
            this.is_once_event_id = "N";
          }
        }
      });
      //console.log("checkOnceEventIdVideo:"+ this.is_once_event_id)
      //this.prepareCartVideo();
      return this.is_once_event_id;
    },
    async prepareCart() {
      if (this.cart_store.cart.length > 0) {
        const image_id = this.cart_store.cart[0].id;
        let _event_key = await this.getEventkeyById(image_id);
        if (_event_key !== "-") {
          let event_detail = await this.getEventDetail(_event_key);

          this.cart_store.addPackage(JSON.parse(JSON.stringify(event_detail.package)).filter(pkg => pkg.type == 'I'));

          if (this.cart_store.is_mhao_flag === "YES") {
            this.cart_store.event_can_mhao = event_detail.is_mhao;
            this.cart_store.mhao_price = event_detail.mhao_price;
            //console.log("this.cart_store.total: " + this.cart_store.total);
          }

          this.insertLogs(image_id, _event_key);
        }
      }
    },
    async prepareCartVideo() {
      //console.log(" prepareCartVideo cart_store.cart_vdo.length: ", this.cart_store.cart_vdo.length);
      if (this.cart_store.cart_vdo.length > 0) {
        const video_id = this.cart_store.cart_vdo[0].id;
        //console.log("video_id: ", video_id);
        let _event_key = await this.getEventkeyByIdVideo(video_id);
        //console.log("_event_key: ", _event_key);
        if (_event_key !== "-") {
          let event_detail = await this.getEventDetail(_event_key);

          this.cart_store.addPackage_video(JSON.parse(JSON.stringify(event_detail.package)).filter(pkg => pkg.type == 'V'));
          //console.log(" this.cart_store._package_video: ",  this.cart_store._package_video);
          //console.log(" this.cart_store json: "+  this.cart_store.is_mhao_flag);
          
          if (this.cart_store.is_mhao_flag === 'YES') {
            this.cart_store.event_can_mhao = event_detail.is_mhao;
            this.cart_store.mhao_price = event_detail.mhao_price;//TODO
            //console.log("this.cart_store.total: " + this.cart_store.total);
          }

          this.insertLogsVideo(video_id, _event_key);
        }else{
          this.cart_store.clear_all_cart_in_cart_page_vdo()
        }
      }
    },
  },
};
</script>

<style scoped>
.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}

.package-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 8px 0 10px;
}

.package-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
  color: #035057;
  background: linear-gradient(135deg, #eef5ff, #e0ecff);
  border: 1px solid #cfe0ff;
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(13, 110, 253, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  white-space: nowrap;
}

.custom-border {
  border: 7px solid #70b3ff; /* สีขาว */
  border-radius: 1em;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); /* เงา */
  padding: 1em;
  transition: border 0.3s ease, box-shadow 0.3s ease;
}
.custom-border:hover {
  border-color: #0d53a8; /* สีตอน hover */
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
}

.align-to-right {
  float: right;
  padding: 10px;
  background-color: hotpink;
}

input[type="checkbox"] {
  display: none;
}

div.gellerycont:hover {
  /* cursor: pointer; */
  opacity: 0.8;
}
@media screen and (min-width: 451px) and (max-width: 9000px) {
  div.gellerycont {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gellerycont img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  div.gellerycont {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 2px;
    border: 1px solid #ccc;
  }

  div.gellerycont img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }
}

.gellerycont {
  position: relative;
  width: auto;
  height: auto;
}

.gellerycont img {
  height: auto;
  width: auto;
}

.gellerycont .video-indicator {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: white;
  background-color: rgba(0, 0, 0, 0.65);
  border-radius: 3px;
  pointer-events: none;
}

.gellerycont .btn {
  position: absolute;
  top: 84%;
  left: 78%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 3px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.gellerycont .btn:hover {
  background-color: black;
}
</style>